import { render, staticRenderFns } from "./basicPro.vue?vue&type=template&id=04186cf7&scoped=true&"
import script from "./basicPro.vue?vue&type=script&lang=js&"
export * from "./basicPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04186cf7",
  null
  
)

export default component.exports